<!-- Всплывающая подсказка при наведении на чип токена в редакторе формулы -->
<template>
  <Teleport to="body">
    <div
      v-if="token"
      class="chip-tooltip"
      :style="{ top: y + 'px', left: x + 'px' }"
    >
      <div class="chip-tooltip__name">{{ token.label }}</div>
      <div
        class="chip-tooltip__type"
        :class="{
          'chip-tooltip__type--source': token.source,
          'chip-tooltip__type--calculated': !token.source && token.paramType === 'calculated',
        }"
      >
        {{ token.source ? "Данные приложения" : token.paramType === "calculated" ? "Расчётный" : "Значение" }}
      </div>

      <div v-if="token.source" class="chip-tooltip__source">
        <span class="chip-tooltip__row-label">Источник</span>
        <span class="chip-tooltip__row-value">
          {{ token.sourceLabel || token.sourceCode }}
        </span>
      </div>

      <div
        v-if="!token.source && token.paramType === 'value' && token.defaultValue !== '' && token.defaultValue != null"
        class="chip-tooltip__row"
      >
        <span class="chip-tooltip__row-label">По умолчанию</span>
        <span class="chip-tooltip__row-value">{{ token.defaultValue }}</span>
      </div>

      <div
        v-if="token.paramType === 'calculated' && token.formula"
        class="chip-tooltip__formula"
      >
        <div class="chip-tooltip__formula-label">Формула</div>
        <div class="chip-tooltip__formula-value">{{ translatedFormula }}</div>
      </div>
    </div>
  </Teleport>
</template>

<script>
export default {
  name: "FormulaChipTooltip",

  props: {
    token: {
      type: Object,
      default: null,
    },
    x: {
      type: Number,
      default: 0,
    },
    y: {
      type: Number,
      default: 0,
    },
    tokenLabels: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    // Заменяет коды параметров в формуле на их названия для читаемого отображения в тултипе
    translatedFormula() {
      if (!this.token?.formula) return "";
      return this.token.formula.replace(
        /[A-Za-z_][A-Za-z0-9_.]*/g,
        (code) => this.tokenLabels[code]?.label || code
      );
    },
  },
};
</script>

<style>
.chip-tooltip {
  position: fixed;
  z-index: 9999;
  transform: translateX(-50%) translateY(-100%);
  min-width: 180px;
  max-width: 300px;
  padding: 10px 12px;
  background: #1e293b;
  color: #f1f5f9;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  pointer-events: none;
}

.chip-tooltip::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid transparent;
  border-top-color: #1e293b;
}

.chip-tooltip__name {
  font-size: 13px;
  font-weight: 600;
  color: #f8fafc;
  margin-bottom: 6px;
}

.chip-tooltip__type {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  background: #3b82f6;
  color: #fff;
  margin-bottom: 8px;
}

.chip-tooltip__type--calculated {
  background: #15803d;
}

.chip-tooltip__type--source {
  border: 1px solid #60a5fa;
  background: transparent;
  color: #bfdbfe;
}

.chip-tooltip__source {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 8px;
  padding-top: 4px;
  border-top: 1px solid #334155;
}

.chip-tooltip__row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 8px;
  margin-top: 4px;
  padding-top: 4px;
  border-top: 1px solid #334155;
}

.chip-tooltip__row-label {
  font-size: 11px;
  color: #94a3b8;
  flex-shrink: 0;
}

.chip-tooltip__row-value {
  font-size: 12px;
  color: #e2e8f0;
  text-align: right;
  word-break: break-all;
}

.chip-tooltip__formula {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #334155;
}

.chip-tooltip__formula-label {
  font-size: 11px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 4px;
}

.chip-tooltip__formula-value {
  font-size: 12px;
  color: #e2e8f0;
  font-family: "Menlo", "Monaco", "Courier New", monospace;
  word-break: break-word;
  line-height: 1.5;
}
</style>
